import { yupResolver } from '@hookform/resolvers/yup'
import React, { useEffect, useId, useRef, useState } from 'react'
// import { useForm } from "react-hook-form";
import { useHistory, useParams } from 'react-router-dom'
import { Button, TextAreaInput, TextInput } from 'components/ui'
import * as yup from 'yup'
import { RouterConfig, UrlConfig } from '../../config'
import { AlertTypeEnum, CodeEnum } from '../../enum'
import { ApiTool, AppTool, PlaceTool, UrlTool } from '../../tool'
import { useForm, useQuery } from '../../useHooks'
import BelongBuilding from '../belongBuilding/belongBuilding'
import MetaDataInputV2 from '../common/metaDataInputV2/metaDataInputV2'
import ConfirmV2 from '../confirmV2/confirmV2'
import CongratsBanner from '../congratsBanner/congratsBanner'
import DialogBody from '../dialogBody/dialogBody'
import MainCategory from '../mainCategory/mainCategory'
import PhotosInputV2 from '../photosInputV2/photosInputV2'
import Subcategory from '../subcategory/subcategory'
import { ImageConfig } from './../../config/imageConfig'
import { LinkIconConfig } from './../../config/linkIconConfig'
import { Resource } from './../../resource'
import AddressInputV2 from './../addressInputV2/addressInputV2'
import BusinessHourInputV3 from './../businessHourInputV3/businessHourInputV3'
import Collapse from './../collapse/collapse'
import LocationInputV2 from './../common/locationInputV2/locationInputV2'
import TagInputV2 from './../common/tagInputV2/tagInputV2'
import Dialog from './../dialog/dialog'
import DialogAction from './../dialogAction/dialogAction'
import DialogHeader from './../dialogHeader/dialogHeader'
import './requestUpdatePoi.scss'

const MAX_LENGTH_NAME = 256
const MAX_LENGTH_DESCRIPTION = 1000
const MAX_SIZE_FILE = 10485760 //convert 10MB to Bytes
const MAX_TOTAL_SIZE_FILES = 104857600 //convert 100MB to Bytes
const ACCEPT_FILES = '.png, .jpg, .jpeg, .webp , .svg'
const REGEX_PHONE_NUMBER = /^[+]?\d+(\s?\d+)*$/
const REGEX_WEBSITE = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/
function RequestUpdatePoi() {
  const history = useHistory()
  const FORM_ID = useId()
  const { id } = useQuery()

  const apiSubmitRef = useRef()
  const apiUploadRef = useRef()
  const timeOutRef = useRef()
  const detailPoiRef = useRef()

  const [showConfirm, setShowConfirm] = useState(false)
  const [showOtherInfo, setShowOtherInfo] = useState(false)
  const [poi, setPoi] = useState(null)
  const [showBanner, setShowBanner] = useState(false)
  const [loadingSubmit, setLoadingSubmit] = useState(false)
  const [name, setName] = useState('')
  const [isChange, setIsChange] = useState(false)

  const schema = yup.object().shape({
    name: yup.string().required(
      Resource.formatString(Resource.validate.required, {
        field: Resource.common.name
      })
    ),

    address: yup.string().required(
      Resource.formatString(Resource.validate.required, {
        field: Resource.common.address
      })
    ),

    phoneNumber: yup
      .string()
      .test(
        'phoneNumberFormat',
        Resource.formatString(Resource.validate.format, { field: Resource.common.phoneNumber }),
        function (phone) {
          if (phone && (!REGEX_PHONE_NUMBER.test(phone) || phone == '0000000000')) {
            return false
          }
          return true
        }
      ),
    website: yup
      .string()
      .test(
        'websiteFormat',
        Resource.formatString(Resource.validate.format, { field: Resource.common.website }),
        function (website) {
          if (website && !REGEX_WEBSITE.test(website)) {
            return false
          }
          return true
        }
      ),

    mainType: yup.string().required(
      Resource.formatString(Resource.validate.required, {
        field: Resource.categoryList.main
      })
    ),

    mediaFiles: yup
      .mixed()
      .nullable()
      .test(
        'formatFile',
        Resource.formatString(Resource.validate.formatImage, { format: ACCEPT_FILES }),
        function (mediaFiles) {
          let check = true
          let format = ['png', 'jpg', 'jpeg', 'webp', 'svg']
          if (mediaFiles?.length > 0) {
            mediaFiles?.forEach((file) => {
              let typeFile = file?.name?.split('.')?.pop()
              if (!format.includes(typeFile?.toLowerCase())) {
                check = false
              }
            })
          }
          return check
        }
      )
      .test(
        'sizeFile',
        Resource.formatString(Resource.validate.maxCapacityImage, { numberUnit: '10MB' }),
        function (mediaFiles) {
          let check = true
          if (mediaFiles?.length > 0) {
            mediaFiles?.forEach((file) => {
              if (file.size > MAX_SIZE_FILE) {
                check = false
              }
            })
          }
          return check
        }
      )
      .test(
        'totalSizeFile',
        Resource.formatString(Resource.validate.maxTotalCapacityImage, { numberUnit: '100MB' }),
        function (mediaFiles) {
          let check = true
          let countSize = 0
          if (mediaFiles?.length > 0) {
            mediaFiles?.forEach((file) => {
              countSize += file?.size
            })
            if (countSize > MAX_TOTAL_SIZE_FILES) {
              check = false
            }
          }
          return check
        }
      )
  })

  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
    getValues,
    isRequiredError
  } = useForm({
    resolver: schema
  })

  useEffect(() => {
    var sourcePlace
    if (id) {
      sourcePlace = ApiTool.get(UrlConfig.poi.detail.replace('{id}', id), (res) => {
        if (res?.code == CodeEnum.ok) {
          let placeNew = res?.result
          detailPoiRef.current = { ...res?.result } || {}
          let isAreaOrStreet = PlaceTool.isAreaOrStreet(placeNew)
          if (isAreaOrStreet) {
            history.push({
              pathname: RouterConfig.home
            })
          }
          setPoi(placeNew)
          setName(placeNew?.name || '')
          setValue('name', placeNew?.name)
          setValue('address', placeNew?.address)
          setValue('phoneNumber', placeNew?.phoneNumber || '')
          setValue('mainType', placeNew?.mainType)
          setValue('website', placeNew?.website || '')
          setValue('description', placeNew?.description || '')
        } else {
          setPlace(null)
        }
      })
    }
    return () => {
      sourcePlace?.cancel()
    }
  }, [id])

  useEffect(() => {
    let poiTrimText = {
      ...poi,
      name: poi?.name?.trim(),
      address: poi?.address?.trim(),
      description: poi?.description?.trim(),
      website: poi?.website?.trim(),
      phoneNumber: poi?.phoneNumber?.trim()
    }
    let dataUpdate = PlaceTool.createRequestPoiV4(detailPoiRef?.current, poiTrimText)
    let check = Object?.keys(dataUpdate)?.length > 0 || poi?.imageFiles?.length > 0
    setIsChange(check)
  }, [poi])

  const onCloseDialog = () => {
    setShowConfirm(true)
  }

  const onConfirmClose = () => {
    history.push({
      pathname: location.pathname,
      search: UrlTool.createSearch({ ep: undefined }, { extendOldQuery: true })
    })
    setPoi(null)
  }

  const onCloseConfirm = () => {
    setShowConfirm(false)
  }

  const onClickOtherInfo = () => {
    setShowOtherInfo((prev) => !prev)
  }

  const onChangeName = (e) => {
    let value = e?.target.value || ''
    setPoi((prev) => {
      return {
        ...prev,
        name: value
      }
    })
    setValue('name', value, { shouldValidate: formState.isSubmitted })
  }

  const onChangeTag = (value) => {
    setPoi((prev) => {
      return {
        ...prev,
        tags: value
      }
    })
  }

  const onChangeMainCategory = (value) => {
    setPoi((prev) => {
      return {
        ...prev,
        mainType: value
      }
    })
    setValue('mainType', value, { shouldValidate: formState.isSubmitted })
  }

  const onChangeSubCategory = (value) => {
    setPoi((prev) => {
      return {
        ...prev,
        auxiliaryTypes: value
      }
    })
  }

  const onChangeAddress = (value) => {
    let valueAddress = value?.address || value || ''
    setPoi((prev) => {
      return {
        ...prev,
        address: valueAddress
      }
    })
    setValue('address', valueAddress, { shouldValidate: formState.isSubmitted })
  }

  const onChangeLocation = (value) => {
    setPoi((prev) => {
      return {
        ...prev,
        location: value
      }
    })
  }

  const onChangeMediaFile = (mediaFiles, imageFiles) => {
    setPoi((prev) => {
      return {
        ...prev,
        mediaFiles: mediaFiles,
        imageFiles: imageFiles
      }
    })
    setValue('mediaFiles', imageFiles, { shouldValidate: formState.isSubmitted })
  }

  const onChangeBusinessHour = (value) => {
    setPoi((prev) => {
      return {
        ...prev,
        businessHours: value
      }
    })
  }

  const onChangeWebsite = (e) => {
    let valueWebsite = e?.target.value || ''
    setPoi((prev) => {
      return {
        ...prev,
        website: valueWebsite
      }
    })
    setValue('website', valueWebsite, { shouldValidate: formState.isSubmitted })
  }

  const onChangePhoneNumber = (e) => {
    let valuePhoneNumber = e?.target.value || ''
    setPoi((prev) => {
      return {
        ...prev,
        phoneNumber: valuePhoneNumber
      }
    })
    setValue('phoneNumber', valuePhoneNumber, { shouldValidate: formState.isSubmitted })
  }

  const onChangeDescription = (e) => {
    let valueDescription = e?.target.value
    setPoi((prev) => {
      return {
        ...prev,
        description: valueDescription
      }
    })
  }

  const onChangeMetaData = (value) => {
    setPoi((prev) => {
      return {
        ...prev,
        metadata: value
      }
    })
  }

  const onChangeBuilding = (value) => {
    setPoi((prev) => {
      return {
        ...prev,
        objectId: value
      }
    })
  }

  const createPoi = (data) => {
    let requestData = PlaceTool.createRequestPoiV4(detailPoiRef.current, data)
    let body = {
      ...requestData,
      placeId: id
    }
    apiSubmitRef?.current?.cancel()
    apiSubmitRef.current = ApiTool.post(
      UrlConfig.poiEdit.create,
      body,
      (res) => {
        setLoadingSubmit(false)
        if (res?.code == CodeEnum.ok) {
          setShowBanner(true)
        } else {
          AppTool.alert(
            res?.message ||
              Resource.formatString(Resource.alert.error.requestUpdate, {
                object: Resource.common.place.toLowerCase()
              }),
            AlertTypeEnum.error
          )
        }
      },
      true
    )
  }

  const onSubmit = (data) => {
    let imageFiles = data?.mediaFiles
    setLoadingSubmit(true)
    timeOutRef?.current && clearTimeout(timeOutRef?.current)
    timeOutRef.current = setTimeout(() => {
      if (imageFiles?.length > 0) {
        let body = {
          files: imageFiles
        }
        apiUploadRef?.current?.cancel()
        apiUploadRef.current = ApiTool.postFormFromJson(
          UrlConfig.file.listMedia,
          body,
          (res) => {
            if (res?.code == CodeEnum.ok) {
              let data = {
                ...(poi || {})
              }
              data.mediaFiles = poi?.mediaFiles?.concat(res?.result)
              createPoi(data)
            } else {
              AppTool.alert(
                res?.message ||
                  Resource.formatString(Resource.alert.error.add, {
                    object: Resource.common.images.toLowerCase()
                  }),
                AlertTypeEnum.error
              )
            }
          },
          true
        )
      } else {
        createPoi(poi)
      }
    }, 300)
  }

  const onCloseBanner = () => {
    setShowBanner(false)
    onConfirmClose()
  }

  return (
    <>
      <Dialog className='RequestUpdatePoiCpn' onClose={onCloseDialog} open={true} disableCloseOnClickBackdrop>
        <DialogHeader subtitle={name || ''}>{Resource.updatePlace.requestUpdate}</DialogHeader>

        <DialogBody>
          <form className='bodyDialog test' id={FORM_ID} noValidate onSubmit={handleSubmit(onSubmit)}>
            <div className='description'>
              <div className='title'>{Resource.place.infoAboutPlace}</div>
              <div className='caption'>{Resource.place.captionInfoPlace}</div>
            </div>

            <div className='mainInfo'>
              <TextInput
                inputRef={register({ name: 'name' })}
                required
                label={Resource.common.name}
                placeholder={Resource.name.add}
                maxLength={MAX_LENGTH_NAME}
                showCount
                value={poi?.name || ''}
                onChange={onChangeName}
                error={errors?.name ? true : false}
                helperText={errors?.name?.message}
              />

              <MainCategory
                inputRef={register({ name: 'mainType' })}
                value={poi?.mainType || ''}
                onChange={onChangeMainCategory}
                error={errors?.mainType ? true : false}
                helperText={errors?.mainType?.message}
              />

              <Subcategory value={poi?.auxiliaryTypes} onChange={onChangeSubCategory} />

              <AddressInputV2
                required
                inputRef={register({ name: 'address' })}
                label={Resource.common.address}
                placeholder={Resource.address.add}
                value={poi?.address || ''}
                onChange={onChangeAddress}
                error={errors?.address ? true : false}
                helperText={errors?.address?.message}
                position={poi?.location}
              />

              <LocationInputV2 value={poi?.location} onChange={onChangeLocation} />
            </div>

            <div className='image'>
              <h4 className='title'>{Resource.place.photo}</h4>
              <div className='description'>{Resource.place.addPhoto}</div>
              <PhotosInputV2
                inputRef={register({ name: 'mediaFiles' })}
                value={poi?.mediaFiles}
                onChange={onChangeMediaFile}
                error={errors?.mediaFiles ? true : false}
                helperText={errors?.mediaFiles?.message}
                accept={ACCEPT_FILES}
              />
            </div>

            <div className='otherInfo' onClick={onClickOtherInfo}>
              <div className='head'>
                <div className='title'>{Resource.place.addOtherInfo}</div>
                <div className='toggle'>
                  {showOtherInfo ? (
                    <img src={LinkIconConfig.common.arrTop} alt='arrTop' />
                  ) : (
                    <img src={LinkIconConfig.common.arrBottom} alt='arrBottom' />
                  )}
                </div>
              </div>
              <div className='description'>{Resource.place.addOtherInfoCaption}</div>
            </div>

            <Collapse open={showOtherInfo}>
              <div className='otherInfoContent'>
                <BusinessHourInputV3
                  value={poi?.businessHours || null}
                  onChange={onChangeBusinessHour}
                  placeholder={Resource.businessHours.addOpenTime}
                />

                <TextInput
                  inputRef={register({ name: 'phoneNumber' })}
                  label={Resource.common.phoneNumber}
                  placeholder={Resource.phoneNumber.add}
                  value={poi?.phoneNumber || ''}
                  onChange={onChangePhoneNumber}
                  error={errors?.phoneNumber ? true : false}
                  helperText={errors?.phoneNumber?.message}
                />

                <TextInput
                  inputRef={register({ name: 'website' })}
                  label={Resource.common.website}
                  placeholder={Resource.website.add}
                  value={poi?.website || ''}
                  onChange={onChangeWebsite}
                  error={errors?.website ? true : false}
                  helperText={errors?.website?.message}
                />

                <BelongBuilding value={poi?.objectId || ''} onChange={onChangeBuilding} location={poi?.location} />

                <TagInputV2 placeholder={Resource.hashTag.add} value={poi?.tags} onChange={onChangeTag} />

                <MetaDataInputV2 value={poi?.metadata} onChange={onChangeMetaData} />

                <TextAreaInput
                  label={Resource.common.description}
                  placeholder={Resource.description.add}
                  value={poi?.description || ''}
                  onChange={onChangeDescription}
                  maxLength={MAX_LENGTH_DESCRIPTION}
                  showCount
                />
              </div>
            </Collapse>
          </form>
        </DialogBody>

        <DialogAction>
          <Button onClick={onCloseDialog} variant='cancel'>
            {Resource.common.cancel}
          </Button>

          <Button
            style={{
              marginLeft: '0.75rem'
            }}
            variant='send'
            type='submit'
            form={FORM_ID}
            loading={loadingSubmit}
            disabled={loadingSubmit || isRequiredError || !isChange}
          >
            {Resource.common.send}
          </Button>
        </DialogAction>
      </Dialog>

      <ConfirmV2
        type='warning'
        open={showConfirm}
        message={Resource.confirmMessage.cancelRequestUpdatePlace}
        onConfirm={onConfirmClose}
        onClose={onCloseConfirm}
      />

      <CongratsBanner
        type='info'
        title={Resource.messageBanner.thankForImproving}
        subTitle={Resource.messageBanner.updateStatusRequest}
        open={showBanner}
        icon={<img src={ImageConfig.banner.likeHand} alt='likeHand' />}
        action={
          <Button variant='close' onClick={onCloseBanner}>
            {Resource.button.done.toLocaleUpperCase()}
          </Button>
        }
        onClose={onCloseBanner}
      />
    </>
  )
}

RequestUpdatePoi.propTypes = {
  //
}

export default RequestUpdatePoi
